import "./libs/jcf/jcf.js";
import "./libs/jcf/jcf.scrollable.js";
import "./libs/jcf/jcf.select.js";
import "./libs/slick";

import {binder} from "./libs/binder";
import {constants} from "./modules/module";
import {mobileNav} from "./modules/mobileNav";
import {stickyHeader} from "./modules/stickyHeader";
import {fullHeightPage} from "./modules/fullHeightPage";
import {animationOnScroll} from "./modules/animationOnScroll";
import {textAnimation} from "./modules/textAnimation";
import {parallax} from "./modules/parallax";
import {copyLinkToBuffer} from "./modules/copyLinkToBuffer";
import {footerLogos} from "./modules/footerLogos";
import {footerMobileMenu} from "./modules/footerMobileMenu";
import {socialSticky} from "./modules/socialSticky";
import {anchors} from "./modules/anchors";
import {resetFormFilters} from "./modules/resetFormFilters";
import {customSelect} from "./modules/customSelect";
import {countersAnimation} from "./modules/countersAnimation";
import {smoothSlider} from "./modules/smoothSlider";
import {titleWorldsAnimation} from "./modules/titleWorldsAnimation";
import {popups} from "./modules/popups";
import {quoteWithVidoe} from "./modules/quoteWithVidoe";
import {resourcesSlider} from "./modules/resourcesSlider";
import {eventsSlider} from "./modules/eventsSlider";
import {eventsSliderSingle} from "./modules/eventsSliderSingle";
import {servicesSlider} from "./modules/servicesSlider";
import {accordion} from "./modules/accordion";
import {tabs} from "./modules/tabs";
import {tabbedSlider} from "./modules/tabbedSlider";
import {heroImagesSlider} from "./modules/heroImagesSlider";
import {cardWithIconSlider} from "./modules/cardWithIconSlider";
import {ourResultsBlock} from "./modules/ourResultsBlock";
import {servicesCardList} from "./modules/servicesCardList";
import {arrowScrollBottom} from "./modules/arrowScrollBottom";
import {textBenefitsSlider} from "./modules/textBenefitsSlider";
import {ourMissionListSliderOnMobile} from "./modules/ourMissionListSliderOnMobile";
import {locationsMapActions} from "./modules/locationsMapActions";


binder({
    bounds: {
        "html": [constants, fullHeightPage],
        ".header": [mobileNav, stickyHeader],
        ".has-animation": animationOnScroll,
        ".text-animation": textAnimation,
        ".has-parallax": parallax,
        ".copy-link": copyLinkToBuffer,
        ".footer-logos": footerLogos,
        ".footer-nav-holder": footerMobileMenu,
        ".featured-image-holder": socialSticky,
        ".has-anchor": anchors,
        ".form-filters": resetFormFilters,
        "select": customSelect,
        ".has-counters-animation": countersAnimation,
        ".smooth-slider": smoothSlider,
        ".title-worlds-animation": titleWorldsAnimation,
        ".popup-opener": popups,
        ".quote-with-video-slider": quoteWithVidoe,
        ".resources-slider": resourcesSlider,
        ".events-slider": eventsSlider,
        ".single-events-slider": eventsSliderSingle,
        ".services-slider": servicesSlider,
        ".accordion": accordion,
        ".tabs-holder": tabs,
        ".tabbed-slider-wrap": tabbedSlider,
        ".hero-images-slider": heroImagesSlider,
        ".card-with-icon-slider": cardWithIconSlider,
        ".our-results-blocks": ourResultsBlock,
        ".services-card-list.slider-on-mobile": servicesCardList,
        ".scroll-next-section": arrowScrollBottom,
        ".text-benefits.slider-on-mobile": textBenefitsSlider,
        ".our-mission-list.slider-on-mobile": ourMissionListSliderOnMobile,
        ".locations-map-slider": locationsMapActions,
    },
    runTests: false
});



// WEBPACK FOOTER //
// ./assets/js/global.js